// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const getReportCodes = data => (
  Array.from(
    data.reduce((a, d, i) => (
      a.add(d.report_code.trim())
    ), new Set())
  )
)

export default getReportCodes
